import { render, staticRenderFns } from "./ManageLists.vue?vue&type=template&id=37649017&scoped=true"
import script from "./ManageLists.vue?vue&type=script&lang=js"
export * from "./ManageLists.vue?vue&type=script&lang=js"
import style0 from "./ManageLists.vue?vue&type=style&index=0&id=37649017&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37649017",
  null
  
)

export default component.exports